<template>
    <b-modal
        :id="'update-assignment-part-model-' + partIn.id"
        :ref="'update-assignment-part-model-' + partIn.id"
        :title="name"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        size="md"
        @ok="onOk"
        @show="onShow()"
        header-class="edit-modal-header"
        body-class="edit-modal-body"
        content-class="edit-modal-content"
        modal-class="apprentice-default-modal edit-modal"
        cancel-variant="outline-primary"
        ok-variant="primary"
        hide-header-close
        :no-enforce-focus="true">
        <div class="assignment-part">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>
            <b-form-group
                :label="$t('common.title')"
                label-for="assignment-part-title-input">
                <b-form-input
                    id="assignment-part-title-input"
                    v-model="title"
                    :placeholder="$t('assignment.title_placeholder_part')">
                </b-form-input>
            </b-form-group>

            <div class="explanation">
                <b-form-group
                    :label="$t('assignment.question_or_explanation')"
                    label-for="assignment-explanation-part-input">
                    <ckeditor
                        id="assignment-explanation-part-input"
                        v-model="text"
                        :editor="editor"
                        :config="editorConfig"></ckeditor>
                </b-form-group>
            </div>

            <b-form-group
                v-if="this.partIn.type_name === 'assignment_question'"
                :label="$t('assignment.minimum_word_count')"
                label-for="assignment-question-min-words-input">
                <b-form-input
                    id="assignment-question-min-words-input"
                    v-model="minWordCount"
                    :placeholder="$t('group.settings.no_minimum_value')"
                    min="0"
                    type="number"></b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-lesson-module-assignment-update-assignment-part-modal-component',
    props: ['partIn'],
    data() {
        return {
            name: this.partIn.name ? this.partIn.name : this.$t('assignment.edit_question'),
            title: this.partIn.name,
            text: this.partIn.text ? this.partIn.text.value : '',
            timeline: false,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'bulletedList',
                        'numberedList',
                        'blockQuote',
                        '|',
                        'undo',
                        'redo',
                        'link',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            hasError: false,
            errorMessage: '',
            minWordCount: 0,
        };
    },

    methods: {
        onOk(bvModalEvent) {
            this.checkForErrors();

            if (this.hasError) {
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.saving();

            const nameData = {
                name: this.title,
                profile_category_id: null,
                min_word_count: this.minWordCount,
                text: this.text,
            };

            this.axios.post(this.routes.assignmentPartUpdate(this.partIn.id), nameData).then(
                (response) => {
                    this.$emit('part-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.name = this.partIn.name ? this.partIn.name : this.$t('assignment.edit_question');
            this.minWordCount = this.partIn.min_word_count ? this.partIn.min_word_count : null;
            this.title = this.partIn.name;
            this.text = this.partIn.text.value !== null ? this.partIn.text.value : '';
            this.hasError = false;
        },

        checkForErrors() {
            this.hasError = false;

            if (this.title && this.title.length > 192) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.name_sub_assignment_may_not_contain_more_than_191_characters');
            }
        },
    },
};
</script>

<style scoped>
.assignment-part:not(:last-of-type),
.info {
    margin-bottom: 30px;
}

.custom-file {
    margin-bottom: 15px;
}

.image-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.add-new-image {
    text-align: right;
    margin-top: 20px;
}
</style>
